/* RESPONSIBLE TEAM: team-automation-foundations */
import Step, { IsCustomerFacing } from 'embercom/models/operator/visual-builder/step';
import type Store from '@ember-data/store';
import { TargetContext } from 'embercom/objects/operator/configuration/custom-bot';
import { SUPPORTED_CHANNELS } from 'embercom/lib/operator/custom-bots/constants-2';
import { INTERCOM_CHANNELS_AND_EMAIL } from 'embercom/lib/operator/custom-bots/constants';

export default class DisableComposer extends Step {
  get supportedChannels() {
    if (this.appService?.app?.canUseFeature('team-rd-services-disable-composer-email-channel')) {
      return [...INTERCOM_CHANNELS_AND_EMAIL];
    }
    return SUPPORTED_CHANNELS.disableComposer;
  }

  static get supportedContexts() {
    return [TargetContext.Conversation, TargetContext.CustomerTicket];
  }

  static get requiredBillingFeature() {
    return 'bot_workflows';
  }

  static get isStepGroupEnding() {
    return true;
  }

  static get isStepTerminal() {
    return true;
  }

  static get canBeCustomerFacing() {
    return IsCustomerFacing.Yes;
  }

  static createNewStep(store: Store): DisableComposer {
    return store.createRecord('operator/visual-builder/step/disable-composer', {
      type: 'operator/visual-builder/step/disable-composer',
    });
  }
}
